import { useEffect } from 'react';

// Browser windows share the stored auth session, but each keeps its own copy in memory. When one
// window logs out or switches org or user, the others reload into the new identity (KAIDEV-3162).
// One channel per window: a BroadcastChannel never hears its own messages.
let identityChannel: BroadcastChannel | undefined;
const getIdentityChannel = () => typeof BroadcastChannel === 'undefined' ? undefined : identityChannel ??= new BroadcastChannel('kai-identity');

export const tellOtherWindowsIdentityChanged = () => getIdentityChannel()?.postMessage('identity-changed');

export const useReloadWhenAnotherWindowChangesIdentity = () => {
  useEffect(() => {
    const channel = getIdentityChannel();
    if (!channel) return;
    const reload = () => window.location.reload();
    channel.addEventListener('message', reload);
    return () => channel.removeEventListener('message', reload);
  }, []);
};
